<template>
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <m-datatable
        :headers="headers"
        :items="items"
        :showExportBtns="false"
        :filters.sync="filters"
      />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('close')">بستن</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import MDatatable from "@/components/m-datatable/MDatatable.vue";

export default {
  name: "StatsDialog",
  components: { MDatatable },
  props: {
    type: { type: String, required: true },
    data: { type: Object, required: true },
  },
  data() {
    return {
      filters: {},
    };
  },
  computed: {
    title() {
      switch (this.type) {
        case "companies":
          return "لیست شرکت‌های فعال";
        case "users":
          return "لیست کاربران فعال";
        case "expiring-subscriptions":
          return "لیست شرکت‌های درحال انقضا";
        case "churned-companies":
          return "لیست شرکت‌های خروجی";
        default:
          return "";
      }
    },
    items() {
      if (this.type === "companies") return this.data.active_companies?.details || [];
      if (this.type === "users") return this.data.active_users?.details || [];
      if (this.type === "expiring-subscriptions") return this.data.expiring_packages?.details || [];
      if (this.type === "churned-companies") return this.data.churned_companies?.details || [];
      return [];
    },
    headers() {
      if (this.type === "companies") {
        return [
          {
            text: "نام شرکت",
            value: "name",
          },
          {
            text: "تعداد کاربران فعال",
            value: "user_company_count",
          },
          {
            text: "تعداد اسناد اخیر",
            value: "recent_sanads_count",
          },
          {
            text: "تاریخ ثبت آخرین سند",
            value: "last_sanad_date",
            getValue: item => item.last_sanad_date?.split(" ")[0],
          },
          {
            text: "ساعت ثبت آخرین سند",
            value: "last_sanad_time",
            getValue: item => item.last_sanad_date?.split(" ")[1],
          },
          {
            text: "مدیر کسب و کار",
            value: "superuser" 
          },
          {
            text: "شماره تماس",
            value: "phone_number" 
          },
        ];
      }

      if (this.type === "users") {
        return [
          { 
            text: "نام",
            value: "name",
          },
          { 
            text: "تعداد ورود اخیر",
            value: "recent_logins_count",
          },
          {
            text: "تاریخ",
            value: "date",
            type: "date",
            getValue: (item) => {
              return item.last_login.split(" ")[0];
            },
          },
          {
            text: "ساعت",
            value: "time",
            filterable: false,
            sortable: false,
            getValue: (item) => {
              return item.last_login.split(" ")[1];
            },
          },
        ];
      }

      if (this.type === "expiring-subscriptions") {
        return [
          { 
            text: "شرکت", 
            value: "company_name",
          },
          { 
            text: "مدیر", 
            value: "manager_name",
          },
          { 
            text: "شماره تماس", 
            value: "phone_number",
          },
          {
            text: "بسته فعلی",
            value: "package_name",
            items: [
              { text: "پایه", value: "TWO" },
              { text: "هوشمند", value: "THREE" },
              { text: "قدرتمند", value: "FOUR" },
              { text: "حقوق و دستمزد", value: "PAYROLL" },
            ],
          },
          { 
            text: "تاریخ ثبت نام / خرید", 
            value: "renewal_date",
          },
          { 
            text: "روز باقی‌مانده", 
            value: "remaining_days",
          },
          { 
            text: "آزمایشی", 
            value: "is_trial", 
            type: "boolean",
          },
          {
            text:"آخرین ورود کاربر",
            value: "last_login",
          }
        ];
      }
      if (this.type === "churned-companies") {
        return [
          {
            text: "شرکت",
            value: "company_name",
          },
          {
            text: "مدیر",
            value: "manager_name",
          },
          {
            text: "شماره تماس",
            value: "phone_number",
          },
          {
            text: "آخرین خرید",
            value: "last_purchase_date",
            getValue: item => item.last_purchase_date?.split(" ")[0],
          },
          {
            text: "تاریخ انقضا",
            value: "last_expire_date",
          },
          {
            text: "روز از انقضا",
            value: "days_since_expire",
          },
          {
            text: "آخرین ورود",
            value: "last_login_date",
            getValue: item => item.last_login?.split(" ")[0],
          },
          {
            text: "ساعت ورود",
            value: "last_login_time",
            sortable: false,
            filterable: false,
            getValue: item => item.last_login?.split(" ")[1],
          },
        ];
      }
      return [];
    },
  },
};
</script>
